import React from 'react';
import {ReactComponent as Column2d} from '../../../../../images/charts/Column2d.svg';
import {ReactComponent as Bar2d} from '../../../../../images/charts/Bar2d.svg';
import {ReactComponent as Doughnut} from '../../../../../images/charts/Doughnut.svg';
import {ReactComponent as Pie} from '../../../../../images/charts/Pie.svg';
import {ReactComponent as Line} from '../../../../../images/charts/Line.svg';
import {ReactComponent as Pyramid} from '../../../../../images/charts/Pyramid.svg';
import {ReactComponent as Funnel} from '../../../../../images/charts/Funnel.svg';
import {ReactComponent as MsColumn} from '../../../../../images/charts/MsColumn.svg';
import {ReactComponent as Gauge} from '../../../../../images/charts/Gauge.svg';
import {ReactComponent as Bubble} from '../../../../../images/charts/Bubble.svg';
import {ReactComponent as Kpi} from '../../../../../images/charts/Kpi.svg';
import {ReactComponent as MsBar} from '../../../../../images/charts/MsBar.svg';
import {ReactComponent as MsLine} from '../../../../../images/charts/MsLine.svg';
import {ReactComponent as MsStackedColumn} from '../../../../../images/charts/MsStackedColumn.svg';
import {ReactComponent as MsStackedBar} from '../../../../../images/charts/MsStackedBar.svg';
import {MultiSeriesChartTypesOptions, SingleSeriesChartTypesOptions} from '../../../chartConsts';

const ChartComponents = {
    [SingleSeriesChartTypesOptions.column2d]: Column2d,
    [SingleSeriesChartTypesOptions.bar2d]: Bar2d,
    [SingleSeriesChartTypesOptions.doughnut2d]: Doughnut,
    [SingleSeriesChartTypesOptions.pie2d]: Pie,
    [SingleSeriesChartTypesOptions.line]: Line,
    [SingleSeriesChartTypesOptions.pyramid]: Pyramid,
    [SingleSeriesChartTypesOptions.angulargauge]: Gauge,
    [SingleSeriesChartTypesOptions.bubble]: Bubble,
    [SingleSeriesChartTypesOptions.funnel]: Funnel,
    [SingleSeriesChartTypesOptions.kpi]: Kpi,
    [MultiSeriesChartTypesOptions.mscolumn2d]: MsColumn,
    [MultiSeriesChartTypesOptions.msbar2d]: MsBar,
    [MultiSeriesChartTypesOptions.msline]: MsLine,
    [MultiSeriesChartTypesOptions.stackedcolumn2d]: MsStackedColumn,
    [MultiSeriesChartTypesOptions.stackedbar2d]: MsStackedBar
};

const ChartExplanationRenderer = ({chartType}) => {
    const ChartComponent = ChartComponents[chartType];

    return ChartComponent ? <ChartComponent /> : null;
};
export default ChartExplanationRenderer;
